<template>
  <div class="py-4 container-fluid">
    <div class="row mb-4">
      <div class="col">
        <h4 class="mb-2">Stocktaking Session</h4>
        <div class="card p-3">
          <div class="d-flex flex-wrap">
            <table>
              <tr>
                <td>
                  <div class="mr-4">
                    <strong>Session:</strong> {{ session_name }}
                  </div>
                </td>
                <td>
                  <div class="mr-4">
                    <strong>Store:</strong> {{ store_name }}
                  </div>
                </td>
                <td>
                  <div class="mr-4">
                    <strong>Status:</strong>
                    <span
                      :class="
                        session.status === 'Active'
                          ? 'badge badge-success'
                          : 'badge badge-danger'
                      "
                    >
                      {{ status }}
                    </span>
                  </div>
                </td>
                <td>
                  <div>
                    <strong>Started:</strong> {{ form_date(start_datetime) }}
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="card p-4">
      <div class="row">
        <div class="col-md-5">
          <label>Item Name</label>
          <Iteminput
            @itemoption-check="setItem"
            :Rowid="'1'"
            :Store_id="store_id"
            :type="'stocks'"
          />
        </div>
        <div class="col-md-2">
          <label>System Qty</label>
          <input
            v-model="systemQty"
            type="number"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-md-2">
          <label>Shelf Qty</label>
          <input
            v-model="shelfQty"
            @input="calculateVariance"
            type="number"
            class="form-control"
          />
        </div>
        <div class="col-md-2">
          <label>Variance</label>
          <input
            v-model="variance"
            type="number"
            class="form-control"
            readonly
          />
        </div>
        <!-- <div class="col-md-2">
          <label>Variance Value</label>
          <input
            v-model="varianceValue"
            type="number"
            class="form-control"
            readonly
          />
        </div> -->
        <div class="col-md-1 d-flex align-items-end">
          <button class="" @click="submitStocktakeItem">Submit</button>
        </div>
      </div>
    </div>

    <div class="data-table-container mt-4">
      <table class="data-table">
        <thead>
          <tr>
            <th>Item Name</th>
            <th>System Quantity</th>
            <th>Shelf Quantity</th>
            <th>Variance</th>
            <th>Time Snapshot</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="entry in stockTakeData" :key="entry.id">
            <td>
              <ItemName
                :ItemName="entry.item_name"
                :ItemBrand="entry.brand_name"
                :ItemStrength="entry.item_strength"
              />
            </td>
            <td>{{ entry.quantity_expected }}</td>
            <td>{{ entry.quantity_counted }}</td>
            <td>{{ entry.variance }}</td>
            <td>{{ form_date(entry.created_at) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import Iteminput from "./components/iteminput.vue";
import ItemName from "./components/ItemName.vue";
import formatDateTime from "../../timezone/utc_local_time";
import showNotification from "../../notification/notify";

export default {
  name: "StocktakeSessionDetails", 
  data() {
    return {
      session: {},
      itemName: "",
      itemId: null,
      systemQty: "",
      shelfQty: "",
      variance: "",
      varianceValue: "",
      sellingPrice: "",
      store_id: this.$route.params.storeLocation,
      session_id: this.$route.params.sessionId,
      session_name: "",
      store_name: "",
      // Data for the stock take report table
      stockTakeData: [],
      start_datetime: "",
      status: "",
    };
  },
  components: {
    Iteminput,
    ItemName,
  },
  methods: {
    form_date(tm) {
      return formatDateTime(tm);
    },
    async fetchSessionDetails() {
      const res = await generalApiRequest(
        `stocktakes/${this.$route.params.sessionId}/items`,
        "GET",
        {},
        1
      );
      console.log(res);

      if (res.status === "success") {
        this.stockTakeData = res.data;
        this.session_name = res.session_details.session_name;
        this.store_name = res.session_details.store_name;
        this.start_datetime = res.session_details.start_datetime;
        this.status = res.session_details.status;
      }
    },
    setItem(item, rowId) {
      console.log(rowId);

      this.itemId = item.id;
      this.systemQty = item.c_quantity;
    },
    calculateVariance() {
      if (this.shelfQty === "" || this.systemQty === "") return;
      this.variance = this.shelfQty - this.systemQty;
      this.varianceValue = this.variance * this.sellingPrice;
    },
    async submitStocktakeItem() {
      if (!this.itemId || this.shelfQty === "") {
        alert("Fill all required fields.");
        return;
      }

      const payload = {
        session_id: this.session_id,
        product_id: this.itemId,
        quantity_expected: this.systemQty,
        quantity_counted: this.shelfQty,
        variance: this.variance,
        variance_equivalent: this.varianceValue,
        remarks: null,
        // company_id: 1, // you can replace with dynamic company_id if available
        created_by: 1, // current user id
      };

      const res = await generalApiRequest(
        "stocktakes/add-item",
        "POST",
        payload,
        1
      );

      if (res.status === "success") {
        // Push into table for display
        // this.stockTakeData.push({
        //   id: res.data.id,
        //   item_name: this.itemName || "Item",
        //   system_quantity: this.systemQty,
        //   shelf_quantity: this.shelfQty,
        //   variance: this.variance,
        //   time_snapshot: new Date().toLocaleString(),
        // });

        // Reset form
        this.itemName = "";
        this.itemId = null;
        this.systemQty = "";
        this.shelfQty = "";
        this.variance = "";
        this.varianceValue = "";
        this.sellingPrice = "";

        showNotification("Successfully added!");
        this.fetchSessionDetails();
      }
    },
    // Method to capitalize column headers for the table
    capitalize(str) {
      if (!str) return "";
      return str
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
  },
  mounted() {
    this.fetchSessionDetails();
  },
};
</script>

<style scoped>
.badge {
  padding: 0.4em 0.7em;
  border-radius: 20px;
}
.badge-success {
  background: #28a745;
  color: #fff;
}
.badge-danger {
  background: #dc3545;
  color: #fff;
}

/* Styles for the stock take report table */
.data-table-container {
  width: 100%;
  overflow-x: auto;
  font-family: sans-serif;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9em;
  background-color: white;
  color: black;
}

.data-table th,
.data-table td {
  padding: 5px;
  border: 1px solid #ddd;
  text-align: left;
}

.data-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}
</style>
